var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-device-page"},[_c('div',{staticClass:"report-device-page__content"},[_c('br'),_c('logos-container-ui',{staticClass:"mb-3",attrs:{"center":""}}),_c('info-device')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }